import { HTTP_METHODS } from "constants/CommonConstants";
import { TOAST_STATUS ,API_LOADING} from "utils/constant";

// Define base URLs
const BASE_URLS = {
  AUTH: "auth",
  ADMIN: "auth/dashboard",
  PROFILE: "profile",
  PAGE: "page",
  DESIGNATION: "designation",
  USER: "user",
  STATUS_CATEGORY: "statusCategory",
  GLOBAL: "global",
  VENUE: "venue",
  BOOKING: "booking",
  BID: "bid",


  ANCILLARY_SERVICE : "ancillaryService",
  ANCILLARY_SERVICE_REVIEW : "ancillaryService/review",
  VENUE_REVIEW : "venue/review",
  VENUE_RECOMMEND : "venue/recommend",


};

// Function to create endpoint object
const createEndpoint = (url, method , toastStatus = false , apiLoading =false) => ({ url, method ,toastStatus ,apiLoading});

// Function to generate CRUD endpoints with options
const generateCrudEndpoints = (baseUrl, options , apis) => {
  const endpoints = {};



  if (options.read) {
    endpoints.READ = createEndpoint(`${baseUrl}`, HTTP_METHODS.GET ,TOAST_STATUS.ON,API_LOADING.OFF);
  }

  if (options.create) {
    endpoints.CREATE = createEndpoint(`${baseUrl}`, HTTP_METHODS.POST ,TOAST_STATUS.ON,API_LOADING.OFF);
  }

  if (options.update) {
    endpoints.UPDATE = createEndpoint(`${baseUrl}/:id`, HTTP_METHODS.PATCH ,TOAST_STATUS.ON,API_LOADING.OFF);
  }

  if (options.delete) {
    endpoints.DELETE = createEndpoint(`${baseUrl}/:id`, HTTP_METHODS.DELETE ,TOAST_STATUS.ON,API_LOADING.OFF);
  }

  if (options.read_one) {
    // Assuming READ_ONE means fetching a single item
    endpoints.READ_ONE = createEndpoint(`${baseUrl}/:id`, HTTP_METHODS.GET ,TOAST_STATUS.OFF,API_LOADING.OFF);
  }

  if(apis){
    for(let apiKey in apis){
      endpoints[apiKey] = apis[apiKey]

    }
  }

  return endpoints;
};

// API Configuration object with options
export const ApiConfig = {
  AUTH: {
    LOGIN: createEndpoint(`${BASE_URLS.AUTH}/login`, HTTP_METHODS.POST ,TOAST_STATUS.OFF,API_LOADING.OFF),
    REGISTER: createEndpoint(`${BASE_URLS.AUTH}/register`, HTTP_METHODS.POST ,TOAST_STATUS.OFF,API_LOADING.OFF),
    OTP: createEndpoint(`${BASE_URLS.AUTH}/login`, HTTP_METHODS.POST , TOAST_STATUS.OFF,API_LOADING.OFF),
    FORGOT: createEndpoint(`${BASE_URLS.AUTH}/login`, HTTP_METHODS.POST ,TOAST_STATUS.OFF,API_LOADING.OFF),
    SOCIAL_LOGIN: createEndpoint(`${BASE_URLS.AUTH}/social-login`, HTTP_METHODS.POST ,TOAST_STATUS.OFF,API_LOADING.OFF),
    FORGOT_PASSWORD: createEndpoint(`${BASE_URLS.AUTH}/forgot-password`, HTTP_METHODS.POST ,TOAST_STATUS.OFF,API_LOADING.OFF),
    RESET_PASSWORD: createEndpoint(`${BASE_URLS.AUTH}/reset-password`, HTTP_METHODS.POST ,TOAST_STATUS.OFF,API_LOADING.OFF),


  },
  GLOBAL: {
    STATE_CITY: createEndpoint(`${BASE_URLS.GLOBAL}/states-cities`, HTTP_METHODS.GET ,TOAST_STATUS.OFF,API_LOADING.OFF),
    HOMEPAGE: createEndpoint(`${BASE_URLS.GLOBAL}/homepage`, HTTP_METHODS.GET ,TOAST_STATUS.OFF , API_LOADING.ON),
    BANNER: createEndpoint(`${BASE_URLS.GLOBAL}/banner`, HTTP_METHODS.GET ,TOAST_STATUS.OFF,API_LOADING.OFF),
    ADVERT: createEndpoint(`${BASE_URLS.GLOBAL}/advertisement`, HTTP_METHODS.GET ,TOAST_STATUS.OFF,API_LOADING.OFF),
    VENUE_CONFIG: createEndpoint(`${BASE_URLS.GLOBAL}/venue-configuration`, HTTP_METHODS.GET ,TOAST_STATUS.OFF,API_LOADING.OFF),
    BANK_LIST: createEndpoint(`${BASE_URLS.GLOBAL}/bank-list`, HTTP_METHODS.GET ,TOAST_STATUS.OFF,API_LOADING.OFF),
    ANC_CONFIG: createEndpoint(`${BASE_URLS.GLOBAL}/anc-configuration`, HTTP_METHODS.GET ,TOAST_STATUS.OFF,API_LOADING.OFF),



  },

  VENUE: generateCrudEndpoints(`${BASE_URLS.VENUE}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  },
  {


   LIST : createEndpoint(`${BASE_URLS.VENUE}/list`, HTTP_METHODS.GET ,TOAST_STATUS.OFF,API_LOADING.OFF ),
   DETAIL : createEndpoint(`${BASE_URLS.VENUE}/detail/:id`, HTTP_METHODS.GET ,TOAST_STATUS.OFF,API_LOADING.OFF ),

   SEARCH_BY_NAME : createEndpoint(`${BASE_URLS.VENUE}/search`, HTTP_METHODS.GET ,TOAST_STATUS.ON,API_LOADING.OFF ),

  //  LIST: createEndpoint(`${BASE_URLS.VENUE}/list`, HTTP_METHODS.GET ,TOAST_STATUS.OFF ),
  // DETAIL: createEndpoint(`${BASE_URLS.VENUE}/detail/:id`, HTTP_METHODS.GET ,TOAST_STATUS.OFF ),


    
    ONBOARDING: createEndpoint(`${BASE_URLS.VENUE}/onboarding`, HTTP_METHODS.POST ,TOAST_STATUS.ON,API_LOADING.OFF ),
    TOP_CATEGORIES: createEndpoint(`${BASE_URLS.VENUE}/topCategories`, HTTP_METHODS.GET ,TOAST_STATUS.OFF ,API_LOADING.ON ),
    TOP_LOCATIONS: createEndpoint(`${BASE_URLS.VENUE}/topLocations`, HTTP_METHODS.GET ,TOAST_STATUS.OFF ,API_LOADING.ON ),
    FILTER: createEndpoint(`${BASE_URLS.VENUE}/filters`, HTTP_METHODS.GET ,TOAST_STATUS.OFF ),



    WRITE_REVIEW: createEndpoint(`${BASE_URLS.VENUE}/:id/review`, HTTP_METHODS.POST ,TOAST_STATUS.ON ,API_LOADING.OFF),
    REQUEST_PRICE_ESTIMATE: createEndpoint(`${BASE_URLS.VENUE}/:id/request-price-estimate`, HTTP_METHODS.POST ,TOAST_STATUS.OFF ,API_LOADING.OFF),
    CHANGE_FAVORITE_STATUS: createEndpoint(`${BASE_URLS.VENUE}/:id/favorite-status`, HTTP_METHODS.PATCH ,TOAST_STATUS.ON ,API_LOADING.ON),



    BOOKING_REQUEST: createEndpoint(`${BASE_URLS.BOOKING}/request`, HTTP_METHODS.POST ,TOAST_STATUS.OFF ,API_LOADING.ON),
    BIDING_REQUEST: createEndpoint(`${BASE_URLS.BID}/request`, HTTP_METHODS.POST ,TOAST_STATUS.OFF ,API_LOADING.ON),


  }
  ),


  ANCILLARY_SERVICE: generateCrudEndpoints(`${BASE_URLS.ANCILLARY_SERVICE}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  },
  {
    LIST : createEndpoint(`${BASE_URLS.ANCILLARY_SERVICE}/list`, HTTP_METHODS.GET ,TOAST_STATUS.OFF,API_LOADING.OFF ),
    ONBOARDING: createEndpoint(`${BASE_URLS.ANCILLARY_SERVICE}/onboarding`, HTTP_METHODS.POST ,TOAST_STATUS.ON,API_LOADING.OFF ),
    CONTACT_US: createEndpoint(`${BASE_URLS.ANCILLARY_SERVICE}/:id/contact-us`, HTTP_METHODS.PATCH ,TOAST_STATUS.OFF ,API_LOADING.OFF),

    WRITE_REVIEW: createEndpoint(`${BASE_URLS.ANCILLARY_SERVICE}/:id/review`, HTTP_METHODS.POST ,TOAST_STATUS.ON ,API_LOADING.OFF),
    REQUEST_PRICE_ESTIMATE: createEndpoint(`${BASE_URLS.ANCILLARY_SERVICE}/:id/request-price-estimate`, HTTP_METHODS.POST ,TOAST_STATUS.OFF ,API_LOADING.OFF),
    CHANGE_FAVORITE_STATUS: createEndpoint(`${BASE_URLS.ANCILLARY_SERVICE}/:id/favorite-status`, HTTP_METHODS.PATCH ,TOAST_STATUS.ON ,API_LOADING.OFF),





    DETAIL: createEndpoint(`${BASE_URLS.ANCILLARY_SERVICE}/detail/:id`, HTTP_METHODS.GET ,TOAST_STATUS.OFF ),
    FILTER: createEndpoint(`${BASE_URLS.ANCILLARY_SERVICE}/filters`, HTTP_METHODS.GET ,TOAST_STATUS.OFF ),


  }
  ),


  ANCILLARY_SERVICE_REVIEW: generateCrudEndpoints(`${BASE_URLS.ANCILLARY_SERVICE_REVIEW}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  },
  {

  }
  ),

  VENUE_REVIEW: generateCrudEndpoints(`${BASE_URLS.VENUE_REVIEW}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  },
  {

  }
  ),

  VENUE_RECOMMEND: generateCrudEndpoints(`${BASE_URLS.VENUE_RECOMMEND}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  },
  {
    LIST : createEndpoint(`${BASE_URLS.VENUE_RECOMMEND}/list`, HTTP_METHODS.GET ,TOAST_STATUS.OFF,API_LOADING.OFF ),
    CHANGE_FAVORITE_STATUS: createEndpoint(`${BASE_URLS.VENUE_RECOMMEND}/:id/favorite-status`, HTTP_METHODS.PATCH ,TOAST_STATUS.ON ,API_LOADING.ON),

  }
  ),





  ADMIN: {
    DASHBOARD: createEndpoint(BASE_URLS.ADMIN, HTTP_METHODS.GET ,TOAST_STATUS.OFF,API_LOADING.OFF),
  },
  PROFILE: generateCrudEndpoints(`${BASE_URLS.PROFILE}`, {
    read: true,
    read_plural: true,  // Example of using read_plural option for pluralized read URL
    create: true,
    update: true,
    delete: true,
    read_one: false,
  }),

  PAGE: generateCrudEndpoints(`${BASE_URLS.PAGE}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: false,
  },
  {
    PAGE_GET_BY_SLUG: createEndpoint(`${BASE_URLS.PAGE}/:slug`, HTTP_METHODS.GET , TOAST_STATUS.OFF ,API_LOADING.ON),



  }
  ),
  USER: generateCrudEndpoints(`${BASE_URLS.USER}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  },
  {
    USER_GET_BY_ROLES: createEndpoint(`${BASE_URLS.USER}/getByRoles`, HTTP_METHODS.POST , TOAST_STATUS.OFF ,API_LOADING.OFF),
    NEWSLETTER_SUBSCRIBE: createEndpoint(`${BASE_URLS.USER}/newsletter`, HTTP_METHODS.POST , TOAST_STATUS.OFF ,API_LOADING.OFF),
    CONTACT_US: createEndpoint(`${BASE_URLS.USER}/contact-us`, HTTP_METHODS.POST , TOAST_STATUS.OFF ,API_LOADING.OFF),


  }
  ),
  DESIGNATION: generateCrudEndpoints(`${BASE_URLS.DESIGNATION}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: false,
  }),
  STATUS_CATEGORY: generateCrudEndpoints(`${BASE_URLS.STATUS_CATEGORY}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  }),
};


